export const USER_ACTIVITY = {
  START: "USER_ACTIVITY.START",
  STOP: "USER_ACTIVITY.STOP",
};

export type AppStateUserActivity = {
  isRunning: boolean;
};

export interface IUserActivityStartRequest {
  type: typeof USER_ACTIVITY.START;
}
export interface IUserActivityStopRequest {
  type: typeof USER_ACTIVITY.STOP;
}

export type UserActivityActionType =
  | IUserActivityStopRequest
  | IUserActivityStopRequest;
